// The app: not signed in, or half-way (the code, a new password, the 2-step set-up) -> the sign-in steps; signed
// in -> the shell with the page of the current URL.
import { BrowserRouter } from 'react-router-dom'
import { TableSkeleton } from '@the-kit/ui'
import { SignInFlow } from './auth/SignInFlow'
import { AppRoutes } from './routes'
import { SessionProvider } from './session'
import { Shell } from './shell/Shell'
import { useSession } from './useSession'

export function App() {
  const session = useSession()
  if (session.isLoading) return <TableSkeleton />
  if (!session.data || session.data.stage !== 'ok') return <SignInFlow session={session.data ?? null} />
  return (
    <SessionProvider session={session.data}>
      <BrowserRouter>
        <Shell>
          <AppRoutes />
        </Shell>
      </BrowserRouter>
    </SessionProvider>
  )
}
